module.exports = __webpack_public_path__ + "static/img/hbd4.0ea4bb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hbd4.png
// module id = b5mM
// module chunks = 0